import { render, staticRenderFns } from "./public-view.vue?vue&type=template&id=6c610d0a&scoped=true&"
import script from "./public-view.vue?vue&type=script&lang=js&"
export * from "./public-view.vue?vue&type=script&lang=js&"
import style0 from "./public-view.vue?vue&type=style&index=0&id=6c610d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c610d0a",
  null
  
)

export default component.exports